import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import { AppComponent } from './app.component';
import { ActionAuctionShared } from './components/auction/action-auction/action-auction.module';
import { CardToBidShared } from './components/auction/card-to-bid/card-to-bid.module';
import { PopupBidsComponent } from './components/modals/popup-bids/popup-bids.component';
import { PopupLoginComponent } from './components/modals/popup-login/popup-login.component';
import { PopupMediaComponent } from './components/modals/popup-media/popup-media.component';
import { PopupOrderAndEntryComponent } from './components/modals/popup-order-and-entry/popup-order-and-entry.component';
import { PopupRealTimeBiddingComponent } from './components/modals/popup-real-time-bidding/popup-real-time-bidding.component';
import { PopupSharedComponent } from './components/modals/popup-shared/popup-shared.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SharedModule } from './components/shared/shared.module';
import { IconModule } from './directives/icon.module';
import { NotifierModule } from 'angular-notifier';
import { configNotifier } from './models/utils';
import { PopupSuperBidsComponent } from './components/modals/popup-super-bids/popup-super-bids.component';
import { RouterModule } from '@angular/router';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PopupRealTimeBiddingComponent,
    PopupLoginComponent,
    PopupBidsComponent,
    PopupMediaComponent,
    PopupOrderAndEntryComponent,
    PopupSharedComponent,
    PopupSuperBidsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDialogModule,
    IconModule,
    SharedModule,
    MatExpansionModule,
    MatSliderModule,
    ActionAuctionShared,
    CardToBidShared,
    MatMenuModule,
    MatBadgeModule,
    RouterModule,
    NotifierModule.withConfig(configNotifier),
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: LOCALE_ID, useValue: 'pt' },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL',
    },
    {
      provide: MatDialogRef,
      useValue: {},
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
